/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.single-cart-item-loop');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(function () {
  	jQuery('.shopping__cart').removeClass("shopping__cart__on");
    jQuery('.body__overlay').removeClass("is-visible");
  },2000);
}

Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id,callback) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      beforeSend: function(){
        if(form_id == "add-item-qv") {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
        }
      },
      data: jQuery('#' + form_id).serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          if(form_id != "add-item-qv") {
            Shopify.cartPopapForm(variant_id);
          } else {
          	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
            jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
            setTimeout(function(){
              	jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
            	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
            }, 2000);
          }
          Shopify.onItemAdded(line_item);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        if(form_id != "add-item-qv") {
          Shopify.onError(XMLHttpRequest, textStatus);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
          setTimeout(function(){
            jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      }
    };
    jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(variant_id) {
  	var image = jQuery('.'+variant_id+':first .popup_cart_image').attr("src");
  	var title = jQuery('.'+variant_id+':first .popup_cart_title').text();
  	jQuery('.popupimage').attr("src",''+image+'');
  	jQuery('.productmsg').text(''+title+'');  
  	jQuery('#modalAddToCart').modal("toggle");
}
Shopify.cartPopapForm = function(variant_id) {
  	var image = jQuery('.product_variant_image').attr("src");
  	var title = jQuery('#popup_cart_title').text();
  	jQuery('.popupimage').attr("src",''+image+'');
	jQuery('.productmsg').text(''+title+'');
	jQuery('#modalAddToCart').modal("toggle");
}

Shopify.formatCartWeight = function(grams) {
  if (!grams || grams <= 0) return '';
  var unit = (window.shop_weight_unit || 'kg').toLowerCase();
  var value = grams;
  if (unit === 'kg') value = grams / 1000;
  else if (unit === 'lb' || unit === 'lbs') value = grams / 453.59237;
  else if (unit === 'oz') value = grams / 28.3495;
  value = Math.round(value * 100) / 100;
  return value + ' ' + unit;
};

Shopify.cartItemHtml = function(item, labels, formatMoney) {
  var title = item.product_title || item.title;
  var variant = item.variant_title;
  var unitGrams = item.grams || 0;
  var lineGrams = unitGrams * (item.quantity || 1);
  var weightHtml = '';
  if (unitGrams > 0) {
    weightHtml = '<span class="form-weight weight">' +
      labels.unit + ' ' + Shopify.formatCartWeight(unitGrams) +
      ' · ' + labels.line + ' ' + Shopify.formatCartWeight(lineGrams) +
      '</span>';
  }
  var variantHtml = '';
  if (variant && variant !== 'Default Title') {
    variantHtml = '<span class="form-variant">' + variant + '</span>';
  }
  var img = item.image ? String(item.image).replace(/^http:/, '') : '';
  var removeFn = 'Shopify.removeItem(' + item.variant_id + ')';

  return '<div class="form-cart-item cart_item">' +
    '<div class="form-cart-img cart_img"><a href="' + item.url + '"><img src="' + img + '" alt=""></a></div>' +
    '<div class="form-cart-info cart_info">' +
      '<a class="form-title" href="' + item.url + '">' + title + '</a>' +
      variantHtml +
      '<span class="form-small-meta quantity">' + labels.qty + ': ' + item.quantity + '</span>' +
      weightHtml +
      '<span class="form-price price_cart">' + Shopify.formatMoney(item.line_price, formatMoney) + '</span>' +
    '</div>' +
    '<div class="form-cart-remove cart_remove"><a href="javascript:void(0);" onclick="' + removeFn + '">&times;</a></div>' +
  '</div>';
};

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = window.money_format;
  var sidebar = document.getElementById('MiniCartSidebar');
  var labels = {
    qty: (sidebar && sidebar.getAttribute('data-label-qty')) || 'Qty',
    unit: (sidebar && sidebar.getAttribute('data-label-unit')) || 'Unit',
    line: (sidebar && sidebar.getAttribute('data-label-line')) || 'Line',
    empty: (sidebar && sidebar.getAttribute('data-label-empty')) || 'Your cart is currently empty.'
  };

  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {
      cart_cell.empty();

      if (cart.items && cart.items.length) {
        jQuery('.single-product-cart, .item-single-item-count, .item-multiple-item-count').css({ display: 'block' });
        jQuery('.cart-empty-title').css({ display: 'none' });

        jQuery.each(cart.items, function(i, item) {
          if (i > 19) return false;
          jQuery(Shopify.cartItemHtml(item, labels, formatMoney)).appendTo(cart_cell);
        });
      } else {
        jQuery('.item-single-item-count, .item-multiple-item-count').css({ display: 'none' });
        cart_cell.html('<p class="cart-empty-title">' + labels.empty + '</p>');
      }
    }
  }

  changeHtmlValue('.shopping-cart__total', Shopify.formatMoney(cart.total_price, formatMoney));
  var lineCount = (cart.items && cart.items.length) ? cart.items.length : 0;
  changeHtmlValue('.bigcounter', lineCount);

  var weightRow = jQuery('[data-cart-total-weight]');
  var weightVal = jQuery('[data-cart-total-weight-value]');
  if (weightRow.length) {
    if (cart.total_weight > 0) {
      weightRow.removeClass('is-empty');
      weightVal.text(Shopify.formatCartWeight(cart.total_weight));
    } else {
      weightRow.addClass('is-empty');
      weightVal.text('');
    }
  }

  if (lineCount > 0) {
    jQuery('#CartCountHeader').show();
  } else {
    jQuery('#CartCountHeader').hide();
  }

  jQuery('.currency .active').trigger('click');
}

function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};
